<h3>System Language Codes</h3>

@if (error && errorMessage) {
  <div class="alert alert-danger alert-dismissible fade show" role="alert" style="margin-top: 10px; margin-bottom: 10px;">
    {{ errorMessage }}
  </div>
}

<div style="width: 100%;">
  <kendo-grid
    [data]="view | async"
    [loading]="systemLanguageCodesService.loading"
    [scrollable]="'none'"
    [pageable]="pageableSettings"
    [pageSize]="state.take"
    [skip]="state.skip"
    [filterable]="'row'"
    [filter]="filter"
    (pageChange)="pageChange($event)"
    (filterChange)="filterChange($event)">
    <ng-template kendoGridToolbarTemplate>
      <div class="d-flex w-100 justify-content-end">
        <button type="button" class="btn btn-outline-dark btn-sm" (click)="addLanguageCode()" title="Add Language Code">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
      </div>
    </ng-template>
    <ng-template kendoGridLoadingTemplate>
      <div class="d-flex justify-content-center align-items-center" style="height: 60px;">
        <div class="spinner-border alfalaval-blue-color" role="status"></div>
      </div>
    </ng-template>
    <kendo-grid-column field="languageCode_ISO639_1" title="ISO 639-1" [width]="110">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains" [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="languageCode_ISO639_3" title="ISO 639-3" [width]="110">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains" [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="languageName" title="Language Name">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains" [showOperators]="false">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="" [width]="90">
      <ng-template kendoGridFilterCellTemplate>
        <span></span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <button class="btn btn-outline-secondary btn-sm me-1" (click)="editLanguageCode(dataItem)" title="Edit">
          <i class="fa fa-edit" aria-hidden="true"></i>
        </button>
        <button class="btn btn-outline-secondary btn-sm" (click)="deleteLanguageCode(dataItem)" title="Delete">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
